import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MultiInvintoryAreaComponent } from "../Layouts/multi-invintory-area/multi-invintory-area.component";
import { GlobalModule } from "../Global/Global.module";
import { LoadingModule } from "../Global/loading/loading.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

@NgModule({
    declarations: [MultiInvintoryAreaComponent],
    imports: [
        CommonModule,
        GlobalModule,
        LoadingModule,
        FormsModule,
        ReactiveFormsModule,
    ],
    exports: [MultiInvintoryAreaComponent],
})
export class MultiSahredComponentsModule {}
